// extracted by mini-css-extract-plugin
module.exports = {"settingsArea":"settingsArea___3yUkQ","productPage":"productPage___7kdk2"};